import { JsonPipe } from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as _enum from './enum'
import * as files from './files'
import * as inlineEnum from './inline-enum'
import * as intrinsic from './intrinsic'
import * as multiReference from './multi-reference'
import * as reference from './reference'

/** TODO:  */
@ngCore.Component({
  imports: [
    // TODO: Remove once everything is implemented
    JsonPipe,
    _enum.Component,
    files.Component,
    inlineEnum.Component,
    intrinsic.Component,
    multiReference.Component,
    reference.Component,
  ],
  selector: 'atn-input-value',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** TODO:  */
  public readonly labelSg = ngCore.input<string>(undefined, {
    alias: 'label',
  })

  /** @see {@link ds.input.select.single.Component._requiredSg}  */
  public readonly requiredSg = ngCore.input<boolean>(false, {
    alias: 'required',
  })

  /**
   * Identifies the pending-upload selection for a Files-typed attribute.
   * Only consumed by the Files branch; ignored for every other value type.
   * TODO: revisit — leaking Files concerns through the generic typed-value pipeline.
   *
   * @see {@link files.Component.documentKeySg}
   */
  public readonly documentKeySg = ngCore.input<
    state.kbDocumentUploads.DocumentKey | undefined
  >(undefined, { alias: 'documentKey' })

  /**
   * Audience used to download/delete already-persisted files. Only consumed
   * by the Files branch; ignored for every other value type.
   * TODO: revisit — leaking Files concerns through the generic typed-value pipeline.
   *
   * @see {@link files.Component.recordTargetSg}
   */
  public readonly recordTargetSg = ngCore.input<
    ents.core.agent.KnowledgeBase.Target.Record | undefined
  >(undefined, { alias: 'recordTarget' })

  /** @see {@link ents.core.dms.data.Value.ValueWithType.Strict} */
  public readonly typedValueSg =
    ngCore.model.required<ents.core.dms.data.Value.ValueWithType.Strict>({
      alias: 'typedValue',
    })

  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly intrinsicTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.common.value.types.Intrinsic.isIntrinsic,
      )
        ? typedValue
        : undefined,
  )
  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly referenceTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Reference.isReference,
      )
        ? typedValue
        : undefined,
  )
  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly multiReferenceTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Reference.Multi.isMulti,
      )
        ? typedValue
        : undefined,
  )
  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly enumTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Enum.isEnum,
      )
        ? typedValue
        : undefined,
  )
  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly inlineEnumTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Enum.Inline.isInline,
      )
        ? typedValue
        : undefined,
  )
  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly structureTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Structure.isStructure,
      )
        ? typedValue
        : undefined,
  )
  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly inlineStructureTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Structure.Inline.isInline,
      )
        ? typedValue
        : undefined,
  )

  /**
   * __NOTE__: Creating a signal to expose value to html in order to avoid
   * calling functions in the html, since functions get executed every time
   * something happens in the UI, even on mouse move
   */
  public readonly filesTypedValueSg = ngCore.computed(
    (typedValue = this.typedValueSg()) =>
      ents.core.dms.data.Value.ValueWithType.Strict.narrow(
        typedValue,
        ents.core.dms.data.Value.Type.Files.isFiles,
      )
        ? typedValue
        : undefined,
  )

  /**
   * The reference input model accepts dimension format as input,
   * but only emits entity ({@link ents.core.dms.data.Value.Reference.Default Default}) format
   * or `undefined`.
   */
  public setReferenceValue(
    type: ents.core.dms.data.Value.Type.Reference,
    value:
      | ents.core.dms.data.Value.Reference.Default
      | ents.core.dms.data.Value.Reference.InFormat.Dimension
      | undefined,
  ): void {
    this.typedValueSg.set({
      type,
      value: ents.core.dms.data.Value.Reference.Default.isDefault(value)
        ? value
        : undefined,
    })
  }
}
